import { useGetTranslationGroup } from '@/state/translations';
import styled from '@emotion/styled';
import { useCurrentDraftGroupId } from '../../hooks/useCurrentDraftGroupId';
import { EDITOR_HEADER_HEIGHT, PAGE_HEADER_HEIGHT } from '../constants';
import CaptionList from './CaptionList';
import LanguageSelect from './LanguageSelect';
import SourceLanguageLabel from './SourceLanguageLabel';
import TranslationVoiceSelect from './TranslationVoiceSelect';

const EditorContainer = styled.div`
    padding-top: 1.6rem;
    height: calc(100vh - ${PAGE_HEADER_HEIGHT});
`;

const Editor = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.black[300]};
    border-radius: 16px 16px 0 0;
    overflow: hidden;
    width: 96rem;
    height: 100%;
    margin: auto;
`;

const EditorHeader = styled.header`
    background-color: ${({ theme }) => theme.colors.black[300]};
    height: ${EDITOR_HEADER_HEIGHT};
    border-bottom: 1px solid ${({ theme }) => theme.colors.black[300]};
    display: grid;
    grid-gap: 1px;
    grid-template-columns: 1fr 1fr;
`;

const HeaderBlock = styled.div`
    background-color: ${({ theme }) => theme.colors.black[50]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 3rem;
`;

function TranslationDraftEditor() {
    const groupId = useCurrentDraftGroupId();
    const { data: groupData } = useGetTranslationGroup(groupId!);

    return (
        <EditorContainer>
            <Editor>
                <EditorHeader>
                    <HeaderBlock>
                        <SourceLanguageLabel language={groupData?.source_language} />
                    </HeaderBlock>
                    <HeaderBlock>
                        <LanguageSelect />
                        <TranslationVoiceSelect />
                    </HeaderBlock>
                </EditorHeader>
                <CaptionList />
            </Editor>
        </EditorContainer>
    );
}

export default TranslationDraftEditor;
